import { useState, useEffect } from 'react';
import Modal from './Modal';

const OWNERS = ['Jason', 'Matt', 'Both'];

export default function GoalModal({ isOpen, onClose, onSave, editItem = null, documents = [] }) {
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    owner: 'Both',
    dueDate: '',
    documentId: ''
  });

  useEffect(() => {
    if (editItem) {
      setFormData({
        title: editItem.title || '',
        description: editItem.description || '',
        owner: editItem.owner || 'Both',
        dueDate: editItem.dueDate || '',
        documentId: editItem.documentId || ''
      });
    } else {
      setFormData({
        title: '',
        description: '',
        owner: 'Both',
        dueDate: '',
        documentId: ''
      });
    }
  }, [editItem, isOpen]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.title.trim() || !formData.dueDate) return;
    onSave(formData);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editItem ? 'Edit Goal' : 'Add Goal'}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Goal Title
          </label>
          <input
            type="text"
            placeholder="e.g., Complete IICRC certification"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            required
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange"
          />
        </div>

        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Description (optional)
          </label>
          <textarea
            placeholder="Additional details..."
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows={2}
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange resize-none"
          />
        </div>

        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Owner
          </label>
          <select
            value={formData.owner}
            onChange={(e) => setFormData({ ...formData, owner: e.target.value })}
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none bg-white focus:border-orange"
          >
            {OWNERS.map((owner) => (
              <option key={owner} value={owner}>
                {owner}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-[13px] font-medium mb-1.5 text-text">
            Due Date
          </label>
          <input
            type="date"
            value={formData.dueDate}
            onChange={(e) => setFormData({ ...formData, dueDate: e.target.value })}
            required
            className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none focus:border-orange"
          />
        </div>

        {documents.length > 0 && (
          <div>
            <label className="block text-[13px] font-medium mb-1.5 text-text">
              Related Document (optional)
            </label>
            <select
              value={formData.documentId}
              onChange={(e) => setFormData({ ...formData, documentId: e.target.value })}
              className="w-full py-2.5 px-3 border border-border rounded-md text-sm outline-none bg-white focus:border-orange"
            >
              <option value="">None</option>
              {documents.map((doc) => (
                <option key={doc.id} value={doc.id}>
                  {doc.name}
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="flex gap-3 mt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 px-5 bg-grey-light text-text border-none rounded-md text-sm font-medium cursor-pointer hover:bg-border"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="flex-1 py-3 px-5 bg-orange text-white border-none rounded-md text-sm font-medium cursor-pointer hover:bg-orange-hover"
          >
            {editItem ? 'Save Changes' : 'Add Goal'}
          </button>
        </div>
      </form>
    </Modal>
  );
}
